import { createApi } from '@/api/modules/utils'

const baseUrl = '/recharge/balance'
const api = createApi(baseUrl)

// 余额充值相关
export const balanceApi = {
  list: api('list', 'get'),
  insert: api('insert', 'post'), // 充值算力
}